/** @type {() => import('@module-federation/enhanced/runtime').FederationRuntimePlugin} */
module.exports = function mfCorsPlugin() {
  return {
    name: 'mf-cors-plugin',
    createScript({ url }) {
      const script = document.createElement('script');
      script.src = url;
      script.setAttribute('crossorigin', 'anonymous');
      return script;
    },
    createLink({ url }) {
      const link = document.createElement('link');
      link.href = url;
      link.rel = 'preload';
      link.as = 'script';
      link.setAttribute('crossorigin', 'anonymous');
      return link;
    },
  };
};
